// TelcoTrack — reusable activity photo thumbs (+ zoom modal), diary/history pattern.

import { Component, Input, OnChanges } from '@angular/core';
import {
  activityPhotosFromIds,
  type ActivityPhotoThumb,
} from '../../utils/activity-photos.util';

@Component({
  selector: 'app-activity-photo-thumbs',
  templateUrl: './activity-photo-thumbs.component.html',
  styleUrls: ['./activity-photo-thumbs.component.scss'],
})
export class ActivityPhotoThumbsComponent implements OnChanges {
  /** Prefer explicit thumbs when already enriched (object history). */
  @Input() photos: ActivityPhotoThumb[] | null | undefined;
  /** Fallback: resolve `/api/objects/photos/:id/download` from ids. */
  @Input() photoIds: unknown;

  resolved: ActivityPhotoThumb[] = [];
  selected: ActivityPhotoThumb | null = null;

  ngOnChanges(): void {
    if (Array.isArray(this.photos) && this.photos.length > 0) {
      this.resolved = this.photos.filter((p) => p?.id && p?.url);
      return;
    }
    this.resolved = activityPhotosFromIds(this.photoIds);
  }

  get hasPhotos(): boolean {
    return this.resolved.length > 0;
  }

  open(photo: ActivityPhotoThumb, event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();
    this.selected = photo;
  }

  close(): void {
    this.selected = null;
  }

  onImageError(event: Event): void {
    const img = event.target as HTMLImageElement | null;
    if (img) img.style.display = 'none';
  }
}
